function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, InputLabel, makeStyles } from '@material-ui/core';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './styles.css';
import IconWrapper from '../../lib/IconWrapper';
import useFormHelpers from '../../hooks/useFormHelpers';
const useStyles = makeStyles(theme => ({
  editorError: {
    border: `2px solid ${theme.palette.error[500]}`
  },
  label: {
    marginBottom: theme.spacing(1)
  }
}));

const RichTextEditor = ({
  error,
  helperText,
  icon,
  id,
  label,
  setValue,
  toolbar,
  ...props
}) => {
  const classes = useStyles();
  return React.createElement(React.Fragment, null, React.createElement(IconWrapper, {
    icon: icon,
    iconTopMargin: -3
  }, React.createElement(InputLabel, {
    htmlFor: id,
    error: error,
    className: classes.label
  }, label)), React.createElement(ReactQuill, _extends({
    onChange: richTextContent => {
      const textContentOnly = richTextContent.replace(/<[^>]*>/g, '').trim(); // user has deleted all content; setting to empty string fixes potential validation issues

      if (textContentOnly === '') {
        setValue('');
      } else {
        setValue(richTextContent);
      }
    },
    modules: {
      clipboard: {
        matchVisual: false
      },
      toolbar
    },
    id: id,
    className: `${error ? classes.editorError : ''}`
  }, props)), helperText && React.createElement(FormHelperText, {
    error: error
  }, helperText));
};

RichTextEditor.propTypes = {
  error: PropTypes.bool,
  helperText: PropTypes.string,
  icon: PropTypes.element,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  toolbar: PropTypes.array
};
RichTextEditor.defaultProps = {
  toolbar: [['bold', 'italic', 'underline'], [{
    list: 'ordered'
  }, {
    list: 'bullet'
  }], [{
    color: []
  }, {
    background: []
  }]]
};

const LinkedRichTextEditor = props => {
  const {
    onBlur,
    value,
    onChange,
    disabled,
    ...helpers
  } = useFormHelpers(props);
  return React.createElement(RichTextEditor, _extends({
    id: props.name,
    setValue: onChange,
    onBlur: () => onBlur({
      target: {
        name: props.name
      }
    }),
    readOnly: disabled,
    value: value || ''
  }, helpers));
};

LinkedRichTextEditor.propTypes = {
  name: PropTypes.string.isRequired
};
export { RichTextEditor, LinkedRichTextEditor };